import Navbar from 'react-bootstrap/Navbar'

function Footer() {
    return (
        <Navbar fixed="bottom" className="justify-content-center">
            <p>Copyright © 2024 <a href="https://www.jamesgunn.dev">James Gunn</a></p>
        </Navbar>
    )
}

export default Footer;